import "../../../design/TableUI.css";
import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_URL } from "../../../api/API_SERVERS";
import Loading from "../../otherComponents/Loading";

export default function AllUsersTable() {
    const [teachers, setTeachers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [search, setSearch] = useState("");

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'waiting': return 'ui-status-passive'; // Using existing shared classes
            case 'passive': return 'ui-status-passive';
            case 'active':  return 'ui-status-active';
            case 'declined': return 'ui-status-danger';
            case 'blocked': return 'ui-status-danger';
            default: return 'ui-status-passive';
        }
    };

    const fetchTeachers = useCallback(async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/api/admin/all-teachers?page=${page}&limit=10`, {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('AdminToken') }
            });
            setTeachers(res.data.teachers || []);
            setTotalPages(res.data.totalPages || 1);
        } catch (e) {
            console.error("Fetch error:", e);
        } finally {
            setLoading(false);
        }
    }, [page]);

    useEffect(() => {
        fetchTeachers();
    }, [fetchTeachers]);

    return (
        <>
            {loading && <Loading />}

            <div className="ui-toolbar">
                <div className="ui-search-wrapper">
                    <input
                        className="ui-search-input"
                        placeholder="Search by Person ID..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <div className="ui-pagination-controls">
                    <button
                        className="ui-page-btn"
                        disabled={page === 1}
                        onClick={() => setPage(prev => prev - 1)}
                    >
                        Prev
                    </button>
                    <span style={{ fontWeight: 600 }}>{page} / {totalPages}</span>
                    <button
                        className="ui-page-btn"
                        /* Change this to >= totalPages to be safe */
                        disabled={page >= totalPages}
                        onClick={() => setPage(prev => prev + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>

            <div className="ui-table-container">
                <table className="ui-custom-table">
                    <thead>
                    <tr>
                        <th>Full Name</th>
                        <th>Person ID</th>
                        <th>Address</th>
                        <th>Status</th>
                        <th>Expiry</th>
                    </tr>
                    </thead>
                    <tbody>
                    {teachers
                        .filter(t => t.person_id?.toLowerCase().includes(search.toLowerCase()))
                        .map((t, idx) => (
                            <tr key={t.id || t.person_id || idx}>
                                <td style={{ fontWeight: 600 }}>{t.fullname}</td>
                                <td style={{ color: 'var(--text-muted)' }}>{t.person_id}</td>
                                <td>{t.address}</td>
                                <td>
                                        <span className={`ui-status-badge ${getStatusClass(t.status)}`}>
                                            {t.status}
                                        </span>
                                </td>
                                <td style={{ color: 'var(--text-muted)' }}>
                                    {t.expiration_date ? t.expiration_date.split('T')[0] : "N/A"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}